import { useContext, useEffect, useState } from "react";
import { DisplaySizeContext } from "src/context/display-size-context";

export default function useIsMobileDisplaySize() {
  const MOBILE_DISPLAY_MAX_WIDTH = 768;
  const { displayWidth } = useContext(DisplaySizeContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(displayWidth <= MOBILE_DISPLAY_MAX_WIDTH);
  }, [displayWidth])

  return isMobile;
}
